import { P2GBox, SvgParcel, P2GText } from '@parcel2go/core-ui';
import type { TFunction } from 'i18next';
import CdnIconProxy from '~/apps/account-linking/components/CdnIconProxy';

export const ParcelCountItem: React.FC<{
  o: number;
  showFaded?: boolean;
  size?: 'md' | 'sm';
  onSelect?: (count: number) => void;
  alignment?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  t: TFunction<string, undefined>;
}> = ({ o, showFaded, size, onSelect, t, alignment }) => (
  <P2GBox
    p={1}
    onClick={() => onSelect?.(o)}
    textAlign="center"
    sx={{
      display: 'flex',
      flexDirection: alignment ?? 'column',
      alignItems: 'center',
      gap: alignment === 'row-reverse' ? 0.5 : 0
    }}
  >
    <div
      style={{ cursor: 'pointer', opacity: showFaded ? 0.3 : 1 }}
      title={
        o == 1
          ? t('ONE_BOX_TITLE', { defaultValue: '1 Box' })
          : t('MULTIPLE_BOXES_TITLE', { defaultValue: '{{count}} Boxes', count: o })
      }
    >
      <CdnIconProxy src="/theme/icons/ParcelLabel.svg" size={size ?? 'sm'} palette="primary">
        <SvgParcel />
      </CdnIconProxy>
    </div>
    <P2GText small colour="primary">
      <strong>{o}x</strong>
    </P2GText>
  </P2GBox>
);
